
export const applyLoose=(value,loose,ErrorClass)=>
loose?value:ErrorClass.normalize(value);